import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const FillLineInfinite = styled(Box)(({ theme, color, seconds }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '0%',
  background: color || theme.palette.primary.A700,
  animation: `fillLine ${seconds}s linear infinite`,
  '@keyframes fillLine': {
    from: { width: '0%' },
    to: { width: '100%' },
  },
}));

FillLineInfinite.propTypes = {
  color: PropTypes.string,
  seconds: PropTypes.number,
};

export default FillLineInfinite;
